import type { Route } from "./+types/about-us-route";
import { AboutUs } from "./components/AboutUs/AboutUs";
import {
  generateSeoMeta,
  generateBreadcrumbSchema,
} from "~/common/utils/seo-meta";

export function meta({}: Route.MetaArgs) {
  return [
    ...generateSeoMeta({
      title: "Про нас - Brandly",
      description:
        "Познайомтеся з командою Brandly. Ми — ентузіасти, які прагнуть спростити управління торговими марками для українського бізнесу.",
      keywords: [
        "brandly",
        "брендлі",
        "команда brandly",
        "про нас",
        "засновники",
        "торгові марки",
      ],
      canonicalUrl: "/about-us",
    }),
    generateBreadcrumbSchema([
      { name: "Головна", url: "/" },
      { name: "Про нас", url: "/about-us" },
    ]),
  ];
}

export default function AboutUsRoute() {
  return <AboutUs />;
}
